import StarRating from './StarRating';

export { SIZES, MAX_STARS } from './StarRating';

export default StarRating;
